// import { PAGE_TITLE } from 'components/common/utils/constants';
const pageTitleReducer = (state = 'CHITS', action) => {
  switch (action.type) {
    case 'SET_PAGE_TITLE': {
      return action.data;
    }
    default:
      return state;
  }
};

export default pageTitleReducer;
